import JSEncrypt from 'jsencrypt';

//**
// RSA加密专用类
// **/
export class RSAHelper {
    private static encryptor = new JSEncrypt();
    //WEB专用密钥
    static RSA_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDvuF8W2ghFIJ8xj/kpXQMAh04PNrLJP9UxFigM7MROvct7MIsn4PKvqF0uOrgIMS15mvONp6JghCkDOg4TKyc/SXtz9C4E/jDHoMy6e/w24WqvvL1T8mk+EftBL2ATjQ4UtW8vQeiyuAGOqfpr7m/tzfRIEoCZq21O8LyryslhywIDAQAB'

    static setPublicKey(publicKey: string): void {
        RSAHelper.encryptor.setPublicKey(publicKey);
    }

    static Encrypt(data: string, privateKeyPem: string = RSAHelper.RSA_KEY): string | false {
        RSAHelper.setPublicKey(privateKeyPem);
        const encrypted = RSAHelper.encryptor.encrypt(data);
        if (!encrypted) throw new Error("RSA 加密失败");
        return encrypted;
    }

    static Decrypt(ciphertext: string, privateKeyPem: string = RSAHelper.RSA_KEY): string {
        RSAHelper.setPublicKey(privateKeyPem)
        const decrypted = RSAHelper.encryptor.decrypt(ciphertext);
        if (!decrypted) throw new Error("RSA 解密失败");
        return decrypted;
    }

}
